export default __webpack_public_path__ + "static/media/lock-icon.5cf8d0f8.svg";